import { render, staticRenderFns } from "./PoliciesProcedures.vue?vue&type=template&id=abc8120a&"
import script from "./PoliciesProcedures.vue?vue&type=script&lang=js&"
export * from "./PoliciesProcedures.vue?vue&type=script&lang=js&"
import style0 from "./PoliciesProcedures.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports